<template>
  <div v-if="hasTranslation">
    {{ translatedText }}
  </div>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState, mapGetters } from 'pinia'

// import { defineAsyncComponent } from 'vue'

export default {
  name: 'I18nDiv',
  components: {},
  props: {
    i18nkey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      translatedText: '',
      hasTranslation: false
    }
  },
  beforeMount() {
    // console.log('i18nDiv GOT BEFORE MOUNT !')
  },
  mounted() {
    this.geti18nTranslation(this.i18nkey).then((result) => {
      //    console.log('i18nDIV TRANSLATE TEXT (%s)', result)
      this.translatedText = result
      this.hasTranslation = true
    })
  },
  methods: {
    ...mapActions(adminStore, ['geti18nTranslation']),
    ...mapGetters(adminStore, [])
  }
}
</script>

<style scoped></style>
